import { Component, OnInit } from '@angular/core';
import { OktaAuthService } from '../../../services/okta-auth.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private oktaAuthService: OktaAuthService) { }

  ngOnInit(): void {
    this.logout();
  }

  async logout() {
    this.oktaAuthService.handleLogout();
  }
}
